export const ENVIRONMENTS = Object.freeze({
	PRODUCTION: "production",
	DEVELOPMENT: "development",
});

export const ENV = ENVIRONMENTS.PRODUCTION;
